<template>
  <div class="cangKuKanBan">
    <h1 style="text-align:center; margin-top: 0vh; line-height: 8vh;">仓库看板</h1>
    <div style="margin: 0vh 1vh;">
      <div style="width: 59%; float: left; margin-right: 1%;">
        <div style="width: 100%; background-color: #2D4054;">
          <div class="chart1" style="width: 47%; height: 22vh; float: left; margin-left: 6%;"/>
          <div class="chart2" style="width: 47%; height: 22vh; float: left;"/>
          <div class="clear"/>
        </div>
        <div style="width: 100%; margin-top: 1vh;">
          <el-table :data="DTQLList" style="width: 100%" height="22vh">
            <el-table-column prop="materialNo" label="缺料物料号" :width="fontSize(1.5)"/>
            <el-table-column prop="materialDescription" label="物料描述"/>
            <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.5)"/>
            <el-table-column prop="orderNum" label="数量" :width="fontSize(1)"/>
          </el-table>
        </div>
        <div style="width: 100%; margin-top: 1vh;">
          <el-table :data="MTQLList" style="width: 100%" height="22vh">
            <el-table-column prop="materialNo" label="缺料物料号" :width="fontSize(1.5)"/>
            <el-table-column prop="materialDescription" label="物料描述"/>
            <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.5)"/>
            <el-table-column prop="orderNum" label="数量" :width="fontSize(1)"/>
          </el-table>
        </div>
      </div>
      <div style="width: 40%; float: right;">
        <div style="width: 100%; height: 11vh; background-color: #2D4054;">
          <div style="width: 37%; float: left; text-align:right; margin-right: 3%; ">
            <div style="margin-top: 2.8vh; line-height: 3vh; font-size: 2.7vh; font-weight: bold;">已发料</div>
            <div style=" line-height: 3vh; font-size: 2.7vh; font-weight: bold;">未接收</div>
          </div>
          <div style="width: 60%; float: right; text-align:left;">
            <span ref="numberGrow" :data-time="time" class="number-grow" :data-value="done">0</span>
          </div>
          <div class="clear"/>
        </div>
        <div style="width: 100%; margin-top: 1vh;">
          <el-table :data="DFLList" style="width: 100%" height="56vh">
            <el-table-column prop="materialNo" label="缺料物料号" :width="fontSize(1.5)"/>
            <el-table-column prop="materialDescription" label="物料描述"/>
            <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.5)"/>
            <el-table-column prop="orderNum" label="数量" :width="fontSize(0.8)"/>
          </el-table>
        </div>
      </div>
      <div class="clear"/>
    </div>
    <div style="margin: 1vh 0 0 1vh;">
      <div style="font-size: 2.6vh; line-height: 3vh; float: left;"> * 每小时出料台数（以接收数量为准）</div>
      <div class="clear"/>
    </div>
    <div style="margin: 1vh 1vh 0 1vh;">
      <el-row style="color: #42FFFF; background-color: #233F70;">
        <el-col :span="2"><div class="orderTable">9:00</div></el-col>
        <el-col :span="2"><div class="orderTable">10:00</div></el-col>
        <el-col :span="2"><div class="orderTable">11:00</div></el-col>
        <el-col :span="2"><div class="orderTable">12:00</div></el-col>
        <el-col :span="2"><div class="orderTable">13:00</div></el-col>
        <el-col :span="2"><div class="orderTable">14:00</div></el-col>
        <el-col :span="2"><div class="orderTable">15:00</div></el-col>
        <el-col :span="2"><div class="orderTable">16:00</div></el-col>
        <el-col :span="2"><div class="orderTable">17:00</div></el-col>
        <el-col :span="2"><div class="orderTable">18:00</div></el-col>
        <el-col :span="2"><div class="orderTable">19:00</div></el-col>
        <el-col :span="2"><div class="orderTable">20:00</div></el-col>
      </el-row>
      <el-row style="background-color: #385B82;">
        <el-col :span="2"><div class="orderTable">{{JSHourSList[1].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[2].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[3].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[4].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[5].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[6].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[7].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[8].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[9].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[10].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[11].sl}}</div></el-col>
        <el-col :span="2"><div class="orderTable">{{JSHourSList[12].sl}}</div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        date: new Date().getTime(),
        time: 2,
        myChart1: null,
        myChart2: null,
        todayDone: 0,
        tomorrowPlan: 0,
        tomorrowDone: 0,
        done: 0,
        DTQLList: [],
        MTQLList: [],
        DFLList: [],
        JSHourSList: [{sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}, {sl: 0}],
      };
    },
    mounted() {
      this.getSpWarehouseList();
      this.getDTQLList();
      this.getMTQLList();
      this.getDFLList();
      this.getJSHourSList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      setInterval(() => {
        this.getSpWarehouseList();
        this.getDTQLList();
        this.getMTQLList();
        this.getDFLList();
        this.getJSHourSList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
      setInterval(() => {
        if(this.DTQLList.length > 3) {
          this.DTQLList.push(this.DTQLList[0]);
          this.DTQLList.splice(0, 1);
        }
        if(this.MTQLList.length > 3) {
          this.MTQLList.push(this.MTQLList[0]);
          this.MTQLList.splice(0, 1);
        }
        if(this.DFLList.length > 10) {
          this.DFLList.push(this.DFLList[0]);
          this.DFLList.splice(0, 1);
        }
      }, 4000);
    },
    methods: {
      getSpWarehouseList() {
        let params = {
          date: this.date,
          line: 1,
        };
        this.$http.get("basic","kanban/getSpWarehouseList", params).then(res => {
          for(let item of res) {
            if(item.name === "当天计划发料数量") {
              this.todayPlan = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天已发料数量") {
              this.todayDone = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "明天计划发料数量") {
              this.tomorrowPlan = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "明天已发料数量") {
              this.tomorrowDone = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "已发料未接收数量") {
              this.done = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.numberGrow(this.$refs.numberGrow);
            this.refreshChart();
          });
        });
      },
      getDTQLList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDTQLList", params).then(res => {
          this.DTQLList = res;
        });
      },
      getMTQLList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getMTQLList", params).then(res => {
          this.MTQLList = res;
        });
      },
      getDFLList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getDFLList", params).then(res => {
          this.DFLList = res;
        });
      },
      getJSHourSList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getJSHourSList", params).then(res => {
          this.JSHourSList = res;
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n当天\n发料 ",
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.23),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "88%",
            data: [this.todayDone/this.todayPlan, this.todayDone/this.todayPlan],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: "实际：" + this.todayDone + "\n\n计划：" + this.todayPlan,
                textStyle: {
                  fontSize: this.fontSize(0.24),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n明天\n发料",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.23),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "88%",
            data: [this.tomorrowDone/this.tomorrowPlan, this.tomorrowDone/this.tomorrowPlan],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: "实际：" + this.tomorrowDone + "\n\n总：" + this.tomorrowPlan,
                textStyle: {
                  fontSize: this.fontSize(0.24),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);
      },
      chartValueFormatter(value1, value2) {
        if (value1 == 0 || value2 == 0) {
          return 0;
        }
        return Math.round(value1 * 100/value2);
      },
      numberGrow(ele) {
        if (ele.dataset.value < 40) {
          ele.innerHTML = ele.dataset.value;
          return;
        }
        let step = Math.floor((ele.dataset.value * 5) / (ele.dataset.time * 100));
        let current = 0;
        let start = 0;
        let t = setInterval(function() {
          start += step;
          if (start > ele.dataset.value) {
            clearInterval(t);
            start = ele.dataset.value;
            t = null;
          }
          if (current === start) {
            return;
          }
          current = start;
          ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        }, 10);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .cangKuKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar, ::-webkit-scrollbar-track {
      background-color: transparent!important;
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .clear{
      clear:both
    }
    .number-grow-warp{
      transform: translateZ(0);
    }
    .number-grow {
      font-family: Arial-BoldMT;
      font-size: 9vh;
      color: #81C3FF;
      letter-spacing: 0.267vh;
      line-height:11vh;
    }
    .orderTable {
      height: 6vh;
      line-height: 6vh;
      font-size: 3.6vh;
      text-align:center;
      border: 0.1vh solid #fff;
    }
  }
</style>
